import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiExternalLink, FiAlertTriangle } = FiIcons;

const RedirectHandler = ({ urls }) => {
  const { shortCode } = useParams();

  useEffect(() => {
    const urlData = urls.find(url => url.shortCode === shortCode);
    
    if (urlData) {
      // Update click count
      const savedUrls = JSON.parse(localStorage.getItem('shortenedUrls') || '[]');
      const updatedUrls = savedUrls.map(url =>
        url.shortCode === shortCode 
          ? { ...url, clicks: (url.clicks || 0) + 1 }
          : url
      );
      localStorage.setItem('shortenedUrls', JSON.stringify(updatedUrls));

      // Redirect after a short delay
      setTimeout(() => {
        window.location.href = urlData.originalUrl;
      }, 2000);
    }
  }, [shortCode, urls]);

  const urlData = urls.find(url => url.shortCode === shortCode);

  if (!urlData) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl border border-red-100 p-12 text-center max-w-md"
        >
          <div className="text-red-400 mb-6">
            <SafeIcon icon={FiAlertTriangle} className="text-6xl mx-auto" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-4">Link Not Found</h1>
          <p className="text-gray-600 mb-6">
            The short link you're looking for doesn't exist or has been removed.
          </p>
          <motion.a
            href="/"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="inline-block bg-gradient-to-r from-emerald-500 to-teal-600 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200"
          >
            Go to Homepage
          </motion.a>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-teal-50 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-2xl shadow-xl border border-emerald-100 p-12 text-center max-w-md"
      >
        <div className="text-emerald-500 mb-6">
          <SafeIcon icon={FiExternalLink} className="text-6xl mx-auto" />
        </div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4">Redirecting...</h1>
        <p className="text-gray-600 mb-6">
          You'll be redirected to your destination in a moment.
        </p>
        <div className="bg-gray-50 p-4 rounded-lg mb-6">
          <p className="text-sm text-gray-500 mb-2">Destination:</p>
          <p className="text-emerald-700 font-mono text-sm break-all">
            {urlData.originalUrl}
          </p>
        </div>
        <div className="w-8 h-8 border-3 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
      </motion.div>
    </div>
  );
};

export default RedirectHandler;